import { Box, Flex, Link as ChakraLink, Text } from "@chakra-ui/react";
import { InquiryStatusBadge } from "@equidefi/portals/components/InquiryStatusBadge";
import { Icon } from "@equidefi/ui/icon";
import type React from "react";
import { Link } from "react-router";

interface InquiryCardProps {
  to: string;
  title: string;
  subtitle?: string;
  status?: string | null;
  actions?: React.ReactNode;
}

export const InquiryCard = ({ to, title, subtitle, status, actions }: InquiryCardProps) => {
  return (
    <Box bg="white" borderRadius="md" boxShadow="md" transition="all 0.2s">
      <ChakraLink
        as={Link}
        to={to}
        w="full"
        textDecoration="none"
        _hover={{ textDecoration: "none" }}
        display="block"
        role="group">
        <Box px={4} py={3} transition="all 0.2s" _groupHover={{ bg: "gray.50" }}>
          <Flex align="center" gap={3}>
            <Box flex={1} minW={0}>
              <Text fontWeight="bold" fontSize="md" m={0} noOfLines={1}>
                {title}
              </Text>
              {subtitle && (
                <Text fontSize="xs" color="gray.500" textTransform="uppercase" m={0} mt={0.5} noOfLines={1}>
                  {subtitle}
                </Text>
              )}
            </Box>
            {status && <InquiryStatusBadge status={status} />}
            <Box flexShrink={0} color="gray.400">
              <Icon.ChevronRight size="1.25em" />
            </Box>
          </Flex>
        </Box>
      </ChakraLink>
      {actions && (
        <Box px={4} pb={3} pt={0}>
          {actions}
        </Box>
      )}
    </Box>
  );
};

export default InquiryCard;
